import { createStore } from "./store.ts";

/**
 * Cookie consent (EU ePrivacy / GDPR). Essential storage (sign-in, guest
 * designs, the bag, PayPal at checkout) needs no consent. Anything optional,
 * such as analytics, must check `allows("analytics")` before it loads.
 */
export interface Consent {
  /** null until the visitor has chosen. */
  decidedAt: string | null;
  analytics: boolean;
  /** The banner is open again from "Cookie settings". */
  reopened?: boolean;
}

export const consentStore = createStore<Consent>(
  { decidedAt: null, analytics: false },
  "memeup.consent.v1",
);

export function decide(analytics: boolean) {
  consentStore.set({ decidedAt: new Date().toISOString(), analytics, reopened: false });
}

export function reopenConsent() {
  consentStore.set((c) => ({ ...c, reopened: true }));
}

export const allows = (what: "analytics") => consentStore.get()[what] === true;
